export default "__VITE_PUBLIC_ASSET__02620c3e__"